import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Car, ArrowRight, AlertTriangle } from "lucide-react";

const SEV = {
  red: { c: "#DC2626", bg: "#FEE2E2" },
  yellow: { c: "#B45309", bg: "#FEF3C7" },
  green: { c: "#15803D", bg: "#DCFCE7" },
};

export default function VeicoliScadenzePanel() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  const allowed = ["admin", "operatore"].includes(user?.role);

  useEffect(() => {
    if (!allowed) return;
    api.get("/veicoli/scadenze", { params: { days: 30 } })
      .then((r) => setData(r.data))
      .catch(() => setData({ count: 0, items: [] }));
  }, [allowed]);

  if (!allowed || !data) return null;

  return (
    <div className="card-shell p-4 md:p-5" data-testid="veicoli-scadenze-panel">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 min-w-0">
          <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: "var(--primary)15", color: "var(--primary)" }}>
            <Car className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <h2 className="font-bold text-base" style={{ fontFamily: "Manrope" }}>Scadenze veicoli</h2>
            <p className="text-xs" style={{ color: "var(--text-muted)" }}>Prossimi 30 giorni · Assicurazione e Bollo interni</p>
          </div>
        </div>
        <span
          className="text-xs md:text-sm font-bold px-3 py-1 rounded-full shrink-0 whitespace-nowrap"
          style={{ background: data.count > 0 ? "#FEE2E2" : "var(--surface-muted)", color: data.count > 0 ? "#DC2626" : "var(--text-muted)" }}
          data-testid="veicoli-scadenze-count"
        >
          {data.count} in scadenza
        </span>
      </div>

      {data.count === 0 ? (
        <div className="text-sm py-3 text-center" style={{ color: "var(--text-muted)" }}>
          Nessuna scadenza nei prossimi 30 giorni 🎉
        </div>
      ) : (
        <div className="space-y-1.5">
          {data.items.slice(0, 6).map((it, i) => {
            const s = SEV[it.severity] || SEV.green;
            return (
              <button
                key={`${it.veicolo_id}-${it.field}-${i}`}
                onClick={() => navigate(`/veicoli?open=${it.veicolo_id}`)}
                className="w-full flex items-center gap-2 md:gap-3 p-2.5 md:p-2 rounded-lg border hover:bg-black/[0.02] text-left transition-colors"
                style={{ borderColor: "var(--border)" }}
                data-testid={`veicoli-scadenza-item-${it.veicolo_id}`}
              >
                <span className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded-md shrink-0" style={{ background: s.bg, color: s.c }}>
                  <AlertTriangle className="w-3 h-3" />
                  {it.days_left < 0 ? "Scaduta" : `${it.days_left}gg`}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold truncate">{it.marca_modello || "Veicolo"} · <span className="font-mono">{it.targa || "—"}</span></div>
                  <div className="text-xs truncate" style={{ color: "var(--text-muted)" }}>{it.label} · scad. {it.scadenza}</div>
                </div>
                <ArrowRight className="w-4 h-4 shrink-0" style={{ color: "var(--text-muted)" }} />
              </button>
            );
          })}
          <button onClick={() => navigate("/veicoli")} className="text-sm md:text-xs font-semibold hover:underline mt-1 py-1" style={{ color: "var(--primary)" }} data-testid="veicoli-scadenze-all">
            Vedi tutti i veicoli →
          </button>
        </div>
      )}
    </div>
  );
}
